import { VideoItemOption } from '../../../../shared-models';

export const BLANK_VIDEO_OPTION: VideoItemOption = {
  title: 0,
  byline: 0,
  portrait: 0,
  transparent: 0,
};
